import { $Enums, NewContract } from '@vae/server/dist/client'
import { FixedProductDetails } from '@vae/server/src/types/synerallApiTypes'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import useUser from '../../../../contexts/hooks/useUser'
import LockInCard from './components/LockInCard'

interface LockInDetailsStepProps {
	setSelectedLockIn: (contract: FixedProductDetails | null) => void
	lockInContracts: FixedProductDetails[] | undefined
	contract: Partial<NewContract>
}

const LockInDetailsStep: React.FC<LockInDetailsStepProps> = ({
	setSelectedLockIn,
	lockInContracts,
	contract,
}) => {
	const selectedContract = lockInContracts?.find(
		x => x.validFrom === contract.lockInValidFrom && x.validTo === contract.lockInValidTo
	)

	const [lockIn, setLockIn] = useState<string | null>(selectedContract?.id ?? null)

	const { user } = useUser()

	const { t } = useTranslation('modals_createContract', { keyPrefix: 'lockInDetailsStep' })

	if (!lockInContracts) return <></>

	const handleLockInChange = (lockIn: FixedProductDetails | null) => {
		setSelectedLockIn(lockIn)
		setLockIn(lockIn?.id ?? null)
	}

	return (
		<div className='lock-in-container'>
			<div className='lock-in-products-description text-text-dark dark:text-white'>
				<div>
					<span>{t('description1')}</span>
				</div>
				<div>
					<span>{t('description2')}</span>
				</div>
				<div>
					<span>{t('description3')}</span>
				</div>
			</div>
			{lockInContracts?.map(contract => {
				const selected = lockIn === contract.id
				const prices =
					user?.language === $Enums.Language.en ? contract.prices.en : contract.prices.fi
				const texts = user?.language === $Enums.Language.en ? contract.texts.en : contract.texts.fi

				return (
					<LockInCard
						key={contract.id}
						id={contract.id}
						selected={selected}
						handleSelect={id => handleLockInChange(id === lockIn ? null : contract)}
						price={prices}
						texts={texts}
					/>
				)
			})}
		</div>
	)
}

export default LockInDetailsStep
